import { FC } from 'react'

import RFFFields from '../../react-final-form-fields'
import { validateRequired, validateMaxSymbols, composeValidators } from '../../../../util/validation'
import { nameofFactory } from '../../../../util'

import { SafetyCaseHazardFormFieldsProps, ISafetyCaseHazardValues } from './safety-case-hazard-form-types'
import { useSafetyCaseRiskMatrixQuery } from '../../../../services'

const validateMaxSymbols5000 = validateMaxSymbols(5000, 'Rationale must not exceed 5000 characters')
const validateMaxSymbols500 = validateMaxSymbols(500, 'Notes must not exceed 500 characters')
const validateMaxSymbols100 = validateMaxSymbols(100, 'Action must not exceed 100 characters')

const nameof = nameofFactory<ISafetyCaseHazardValues>()

const nameLabel = 'Hazard Title'
const descriptionLabel = 'Description'
const riskMatrixLevelLabel = 'Risk Matrix Level'
const riskMatrixRationaleLabel = 'Risk Matrix Rationale'
const sortOrderLabel = 'Sort Order'

const SafetyCaseHazardFormFields: FC<SafetyCaseHazardFormFieldsProps> = props => {
  const { disabled, values, isViewMode } = props

  const riskMatrixQuery = useSafetyCaseRiskMatrixQuery(undefined, undefined)

  const riskMatrixData = riskMatrixQuery?.data ?? null

  return (
    <>
      <RFFFields.Input
        name={nameof('name')}
        label={nameLabel}
        placeholder="Enter the short name for this hazard (e.g., 'Gate Area Trip Hazard')"
        disabled={disabled}
        isViewMode={isViewMode}
        validate={composeValidators(validateRequired, validateMaxSymbols100)}
      />

      <RFFFields.Textarea
        name={nameof('description')}
        label={descriptionLabel}
        placeholder="Summarize the hazard in your own words"
        disabled={disabled}
        isViewMode={isViewMode}
        validate={validateMaxSymbols500}
      />

      <RFFFields.MaskedInput
        type="number"
        name={nameof('sortOrder')}
        label={sortOrderLabel}
        placeholder="Enter sort order"
        disabled={disabled}
      />

      <RFFFields.RiskMatrixPicker
        name={nameof('selectedRiskMatrixCell')}
        label={riskMatrixLevelLabel}
        placeholder={'Select ' + riskMatrixLevelLabel}
        disabled={riskMatrixQuery.isFetching || disabled}
        isViewMode={isViewMode}
        data={riskMatrixData}
      />

      {values.selectedRiskMatrixCell && (
        <RFFFields.Textarea
          name={nameof('riskMatrixRationale')}
          label={riskMatrixRationaleLabel}
          placeholder="Explain the reasoning for the selected risk matrix level."
          disabled={disabled}
          isViewMode={isViewMode}
          validate={composeValidators((value: string) => {
            const requiredError = validateRequired(value)
            if (requiredError) {
              return 'Risk Rating Rationale is required when a Risk Matrix Level is assigned'
            }
            return undefined
          }, validateMaxSymbols5000)}
        />
      )}
    </>
  )
}

export default SafetyCaseHazardFormFields
